import { useMemo, useState } from "react";
import { useNavigate } from "react-router";
import TableFC, {
  TableFCBodyProps,
  TableHeadProps,
} from "../../../components/table/Table";
import TableHeader from "../../../components/table/TableHeader";
import { MainPadding } from "../../../styles/Main.styles";
import { useGetUsers } from "../network/resolver";
import { useUserInformation } from "../../../context/userInformation/UserInformationContext";
import { useGenerateTableMapOptions } from "../../../hooks/useHelper";
import Transition from "../../../components/transition/Transition";
import UserFormViewer from "./UserFormViewer";
import DialogFC from "../../../components/dialog/Dialog";
import { IUserData } from "../type/user";

export default function User() {
  const navigate = useNavigate();
  const { roles } = useUserInformation();
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [showTranslate, setShowTranslate] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState<IUserData>();
  const { data: dataRoleTableMap } = useGenerateTableMapOptions(
    roles,
    "value",
    "key"
  );
  const { data: dataRawUsers, isLoading: loadingUsers } = useGetUsers({
    keyword,
    page,
    perPage,
  });
  const dataUsers = dataRawUsers?.data?.data?.data;
  const isLoading = roles.length <= 0 || loadingUsers;
  const header: TableHeadProps[] = [
    { title: "No" },
    { title: "Nama" },
    { title: "Role" },
  ];
  const bodyTable = useMemo(() => {
    if (dataRoleTableMap.length > 0) {
      const bodyTable: TableFCBodyProps[] = [
        { key: "name" },
        { key: "role", isMap: dataRoleTableMap },
      ];
      return bodyTable;
    }
    return null;
  }, [dataRoleTableMap]);

  return (
    <MainPadding>
      <Transition showTranslate={showTranslate}>
        <Transition.Default>
          <TableHeader
            addButton
            filterLabel="Search User"
            searchBar
            onSearch={(e) => setKeyword(e)}
            onClickAdd={() => {
              navigate("/user", { replace: true });
              setShowTranslate(true);
            }}
          />
          <TableFC
            showSkeleton={bodyTable === null}
            loading={isLoading}
            data={dataUsers}
            body={bodyTable || []}
            showIndex
            totalRows={dataRawUsers?.data.data?.total}
            perColumns={perPage}
            onPerPageChange={(e) => setPerPage(e)}
            head={header}
            onPageChange={(e) => setPage(e)}
            onCellClick={(e) => {
              navigate(`/user?id=${e.id}`);
              setShowTranslate(true);
            }}
          />
        </Transition.Default>
        <Transition.Translate>
          <UserFormViewer onClose={() => setShowTranslate(false)} />
        </Transition.Translate>
      </Transition>
      <DialogFC
        open={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
      >
        <DialogFC.Confirm
          title="Hapus"
          description="Anda yakin ingin menghapus user ini ?"
          onCancel={() => setShowDeleteDialog(false)}
          onOk={() => console.log(selectedUser)}
        />
      </DialogFC>
    </MainPadding>
  );
}
